'use strict';

exports.__esModule = true;
exports.pendingLabels = pendingLabels;

var _gateway = require('../network/gateway');

var _gateway2 = _interopRequireDefault(_gateway);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  pendingLabels: '/pending_orders_labels'
};

var PendingLabels = {
  pendingLabels: pendingLabels
};

exports.default = PendingLabels;

/**
 * Wrapper for `/pending_orders_labels` API endpoint
 */

function pendingLabels() {
  return _gateway2.default.get({
    route: API.pendingLabels,
    includeAuth: true
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/gateway/pending-labels.js
// module id = 1204
// module chunks = 0